/** OrderingQueueRoute — pass-through; OrderingQueue owns its masthead. */
import OrderingQueue from "./OrderingQueue";

export default function OrderingQueueRoute() {
  return <OrderingQueue />;
}
